import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import { BreakpointValueProp } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getBreakpointIndex from "@toolkit/Framework/Common/Utilities/getBreakpointIndex";
import getFullBreakpointValues from "@toolkit/Framework/Common/Utilities/getFullBreakpointValues";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";

const getCurrentBreakpointValue = <T extends BreakpointValueProp<any>>(
    values: T,
    currentBreakpoint: BreakpointKey | undefined,
    theme: StyledTheme,
) => {
    if (!currentBreakpoint) {
        return undefined;
    }

    return getFullBreakpointValues(values, theme.breakpoints.keys.length)?.[
        getBreakpointIndex(currentBreakpoint, theme)
    ];
};

export default getCurrentBreakpointValue;
